import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import SanctionsWarningRows from './SanctionsWarningPod.Rows';
import { SanctionsWatchlistTableOverlay } from '../../../../../containers/SanctionsWarnings/SanctionsWarnings.containers';
import utils from '../../../../../utils/utilities';
import api from '../../Dashboard.api';
import { isEqual, sortBy, filter } from 'lodash';
import { withRouter } from 'react-router';

export const ERROR = 'Error fetching data';

class SanctionsWarning extends Component {

    static propTypes = {
        swEntities: PropTypes.array,
        days:       PropTypes.number,
        entities:   PropTypes.object,
        pestle:     PropTypes.object,
        risk:       PropTypes.object
    };

    static defaultProps = {
        swEntities: null,
        days:       30,
        entities:   {},
        pestle:     {
            economic:      true,
            environmental: true,
            legal:         true,
            political:     true,
            social:        true,
            technological: true
        },
        risk:       {
            high:   true,
            low:    false,
            medium: false
        }
    };


    constructor(props) {
        super(props);

        this.state = {
            entityTitle:        '',
            sanctionedEntities: null,
            overlayVisible:     false
        };

        this.loadData = this.loadData.bind(this);
    }

    componentWillMount() {
        this.loadData(this.props.days, this.props.entities, this.props.pestle, this.props.risk, this.props.language);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.days !== nextProps.days ||
            !isEqual(this.props.pestle, nextProps.pestle) ||
            !isEqual(this.props.risk, nextProps.risk) ||
            !isEqual(this.props.entities, nextProps.entities)) {
            this.setState({sanctionedEntities: null});
            this.loadData(nextProps.days, nextProps.entities, nextProps.pestle, nextProps.risk, nextProps.language);
        }
    }

    loadData(days, entities, pestle, risk, language) {
        let catFilter = utils.buildDashboardFilter(entities, risk, pestle, days, language);
        this.props.loadComplete(null);

        return api.getSanctionedEntities(catFilter)
            .then((companies) => {
                let sanctionedEntities = filter(companies, ['hasSanctionsAndWatchLists', true]);
                if (sanctionedEntities.length === 0) {
                    let nullSanctionedEntities = filter(companies, ['hasSanctionsAndWatchLists', null]);
                    if (nullSanctionedEntities.length !== 0) {
                        this.setState({sanctionedEntities: ERROR});
                        return;
                    }
                }
                this.setState({sanctionedEntities: sortBy(sanctionedEntities, ['title'])});
                this.props.loadComplete(sanctionedEntities);
            })
            .catch((error) => {
                utils.logError(error, 'SanctionsWarning.loadData():');
                this.setState({sanctionedEntities: ERROR});
                this.props.loadComplete(null);
            });
    }

    render() {

        if(this.state.sanctionedEntities === ERROR) {
            return (
                <div className="dashboard-page__trending--sanctions">
                    <div className="sanctions-title">
                        <FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.sanctionsAndWarnings" />
                    </div>
                    <div className="sanctions-body">
                        <table>
                            <tbody>
                                <tr>
                                    <td colSpan="8"><FormattedMessage id="Entities_Dossier_UIText_dossierServiceUnavailable" /></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        }

        return (
            <div className="dashboard-page__trending--sanctions">
                <div className="sanctions-title">
                    <FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.sanctionsAndWarnings" />
                    {
                        this.props.swEntities ?
                            <span> (
                                <FormattedMessage id={"Dashboard_Charts_UIText_dashboard.sanctionsPod.sanctionsAndWarnings.entitiesNumber"}
                                                  values={{entitiesLength: this.props.swEntities.length}} />
                            )</span>
                            : null
                    }
                </div>

                <div className="sanctions-body">
                    <table>
                        {
                            !this.props.swEntities ?
                                <tbody>
                                    <tr>
                                        <td colSpan="8" className="inline-spinner"></td>
                                    </tr>
                                </tbody>
                                :
                                <SanctionsWarningRows sanctionedEntities={this.props.swEntities} />
                        }
                    </table>

                </div>

                { this.state.overlayVisible &&
                <SanctionsWatchlistTableOverlay
                    title={this.state.entityTitle + ": " + this.props.intl.formatMessage({ id: "Dashboard_Charts_UIText_dashboard.sanctionsPod.overlayHeader"})}
                    closeOverlay={this.closeSanctionsOverlay}
                    entityName={this.state.entityTitle}
                    companyId={this.state.companyId}
                />
                }

            </div>
        );

    };
}

export default withRouter(injectIntl(SanctionsWarning));


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/SanctionsWarningPod/SanctionsWarningPod.jsx